var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"d-selfservice-page-custom"},[_c('PageHeader',_vm._b({attrs:{"use-wide-image":""}},'PageHeader',{
			..._vm.$attrs,
			..._vm.$props,
		},false)),_vm._v(" "),_c('BlockList',{staticClass:"mt-5xl",attrs:{"block-list":_vm.contentElements},scopedSlots:_vm._u([(
				_vm.link ||
				(_vm.supportBox &&
					(_vm.supportBox.title ||
						_vm.supportBox.openingHours ||
						_vm.supportBox.phone))
			)?{key:"aside",fn:function(){return [_c('div',{class:[
					'd-selfservice-page-custom__aside',
					'sticky top-6xl mb-md >=1024:mb-0 >=1024:max-w-3/12col',
				]},[(_vm.link && _vm.link[0])?_c('div',{staticClass:"flex flex-col items-center >=1024:max-w-fit"},[_c('NuxtLinkExt',{staticClass:"w-full >=1024:w-auto",attrs:{"to":_vm.link[0].url,"target":_vm.link[0].target}},[_c('BaseButton',{staticClass:"d-selfservice-page-custom__aside-button brea",attrs:{"tag":"div"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('span',{domProps:{"textContent":_vm._s(_vm.link[0].name)}})]},proxy:true},{key:"icon",fn:function(){return [_c('SvgArrow',{staticClass:"transform -rotate-45"})]},proxy:true}],null,false,2365796430)})],1),_vm._v(" "),(_vm.requiredNemId)?_c('span',{class:[
							'mt-2xs',
							'font-medium font-darker-grotesque',
							'text-mit-id text-text-placeholder',
						],domProps:{"textContent":_vm._s('Kræver MitID')}}):_vm._e()],1):_vm._e(),_vm._v(" "),(
						_vm.supportBox &&
						(_vm.supportBox.title ||
							_vm.supportBox.openingHours ||
							_vm.supportBox.phone)
					)?_c('div',{class:[
						'max-w-2/12col',

						{
							'hidden >=1024:block': true,
							'mt-2xl': _vm.link && _vm.link[0],
						},
					]},[(_vm.supportBox.title)?_c('h2',{class:[
							'font-darker-grotesque font-extrabold text-aside-title uppercase',
						],domProps:{"innerHTML":_vm._s(_vm.supportBox.title)}}):_vm._e(),_vm._v(" "),_vm._l(([
							_vm.supportBox.phone && {
								label: _vm.supportBox.phoneLabel,
								value: _vm.supportBox.phone,
							},
							_vm.supportBox.openingHours && {
								label: _vm.supportBox.openingHoursLabel,
								value: _vm.supportBox.openingHours,
							},
						].filter(Boolean)),function(item,index){return [_c('dt',{key:`title-${index}`,staticClass:"font-darker-grotesque text-aside-title font-bold uppercase",class:{
								'mt-lg': index || _vm.supportBox.title,
							},domProps:{"innerHTML":_vm._s(item.label)}}),_vm._v(" "),_c('dd',{key:`data-${index}`,staticClass:"font-darker-grotesque text-aside font-medium mt-6",domProps:{"innerHTML":_vm._s(item.value)}})]})],2):_vm._e()])]},proxy:true}:null,{key:"before",fn:function(){return [(
					(_vm.thisIsWhatYouNeed && _vm.thisIsWhatYouNeed.length) ||
					(_vm.thisIsHowYouDo && _vm.thisIsHowYouDo.length)
				)?_c('div',{staticClass:"s-rich-text",class:_vm.contentElements && _vm.contentElements.length && 'mb-5xl'},[(_vm.thisIsWhatYouNeed && _vm.thisIsWhatYouNeed.length)?_c('div',[_c('BaseH3',{attrs:{"tag":"h2"},domProps:{"textContent":_vm._s('Du får brug for')}}),_vm._v(" "),_c('ul',_vm._l((_vm.thisIsWhatYouNeed),function(item,index){return _c('li',{key:`you-need-${index}`,domProps:{"textContent":_vm._s(item)}})}),0)],1):_vm._e(),_vm._v(" "),(_vm.thisIsHowYouDo && _vm.thisIsHowYouDo.length)?_c('div',{staticClass:"mt-3xl"},[_c('BaseH3',{attrs:{"tag":"h2"},domProps:{"textContent":_vm._s('Sådan gør du')}}),_vm._v(" "),_c('ol',_vm._l((_vm.thisIsHowYouDo),function(item,index){return _c('li',{key:`you-do-${index}`,domProps:{"textContent":_vm._s(item)}})}),0)],1):_vm._e()]):_vm._e()]},proxy:true},{key:"after",fn:function(){return [(
					_vm.supportBox &&
					(_vm.supportBox.title ||
						_vm.supportBox.openingHours ||
						_vm.supportBox.phone)
				)?_c('div',{class:{
					'>=1024:hidden': true,
					'mt-7xl': _vm.link && _vm.link[0],
				}},[(_vm.supportBox.title)?_c('BaseH2',{staticClass:"mb-xl",domProps:{"innerHTML":_vm._s(_vm.supportBox.title)}}):_vm._e(),_vm._v(" "),_c('dl',{staticClass:"grid grid-cols-3 gap-x-layout-gutter",staticStyle:{"grid-template-columns":"auto auto 1fr !important"}},[_vm._l(([
							_vm.supportBox.phone && {
								label: _vm.supportBox.phoneLabel,
								value: _vm.supportBox.phone,
							},
							_vm.supportBox.openingHours && {
								label: _vm.supportBox.openingHoursLabel,
								value: _vm.supportBox.openingHours,
							},
						].filter(Boolean)),function(item,index){return [_c('dt',{key:`title-${index}`,staticClass:"row-start-1 font-darker-grotesque text-aside-title font-bold uppercase",class:index ? 'col-start-2' : 'col-start-1',domProps:{"innerHTML":_vm._s(item.label)}}),_vm._v(" "),_c('dd',{key:`data-${index}`,staticClass:"row-start-2 font-darker-grotesque text-aside font-medium",class:index ? 'col-start-2' : 'col-start-1',domProps:{"innerHTML":_vm._s(item.value)}})]})],2)],1):_vm._e()]},proxy:true}],null,true)}),_vm._v(" "),(
			(_vm.showRelatedPages &&
				_vm.showRelatedPages.pages &&
				_vm.showRelatedPages.pages.length) ||
			(_vm.showMorePages &&
				_vm.showMorePages.pages &&
				_vm.showMorePages.pages.length)
		)?_c('div',{staticClass:"mt-5xl space-y-5xl"},[(
				_vm.showRelatedPages &&
				_vm.showRelatedPages.pages &&
				_vm.showRelatedPages.pages.length
			)?_c('RelatedPages',_vm._b({},'RelatedPages',{ ..._vm.showRelatedPages, links: _vm.showRelatedPages.pages },false)):_vm._e(),_vm._v(" "),(
				_vm.showMorePages &&
				_vm.showMorePages.pages &&
				_vm.showMorePages.pages.length
			)?_c('RelatedPages',_vm._b({attrs:{"grey":""}},'RelatedPages',{ ..._vm.showMorePages, links: _vm.showMorePages.pages },false)):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.hideFeedback)?_c('FeedbackModule',{staticClass:"mt-7xl",attrs:{"feedback":_vm.feedback}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }